/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2014, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../app/nls/StringResources',
	'jquery',
	'doT',
	'text!./InlineMessage.html',
	'@ba/ba-graphics/dist/icons-js/error--filled_24'
], function (Class, resources, $, dot, templString, errorIcon) {

	var ErrorView = Class.extend({

		/**
		 * Constructor
		 */
		init: function() {
			ErrorView.inherited('init', this, arguments);

			this.msgTempl = dot.template(templString || '');
		},

		/**
		 * Render container
		 *
		 * @param {object} data - error data
		 * @param {string} data.id - error id
		 * @param {object} data.msg - error message
		 * @param {string} data.msg.str - error message string
		 * @param {any} [data.msg.params] - error message string params
		 *
		 * @return {string} error message container
		 */
		renderContainer: function(data) {
			var msg = this.makeNlsMessage(data.msg);
			return $(this.msgTempl({
				id: data.id,
				msg: msg,
				errorIcon: errorIcon.default
			}));
		},

		makeNlsMessage: function(msg) {
			return msg.params ? resources.get(msg.str, msg.params) : resources.get(msg.str);
		}
	});

	return ErrorView;
});
